import React from 'react';
import { Price } from 'ui/Price';
import { useCurrentWidth } from 'effects';
import { RIGHT_COLUMN_BREAKPOINT } from './const';
import { BookingBuilder } from 'services/BackendApi';

interface IBookingRightTotalCostProps {
  booking: BookingBuilder;
  className?: string;
}

export const BookingRightTotalCost: React.FC<IBookingRightTotalCostProps> = React.memo(({ booking, className }) => {
  const { currentWidth } = useCurrentWidth();
  const priceClassName = 'font-hurmegeometric-sans text-19px leading-20px font-semibold text-right mt-5px m-0';

  return (
    <div className="booking-right-total-cost bg-green-25 flex justify-between items-center min-h-[76px] p-[15px]">
      <div className="flex flex-row items-center justify-end mt-[5px]">
        <p className="total-cost ml-1 font-hurmegeometric-sans text-[19px] leading-[23px] text-flint uppercase font-semibold m-0">
          TOTAL {currentWidth > RIGHT_COLUMN_BREAKPOINT ? 'COST' : ''}
        </p>
      </div>

      <Price
        total={booking.response.totals.total}
        totalBeforeDiscount={booking.response.totals.totalBeforeDiscount}
        currencyCode={booking.response.currency}
        isOnRequest={booking.response.totals.oneOrMoreItemsOnRequest}
        totalClassName={`${priceClassName} text-black`}
        totalBeforeDiscountClassName={`font-hurmegeometric-sans text-15px leading-18px text-right mt-5px m-0 text-gray-80 line-through`}
        totalAfterDiscountClassName={`${priceClassName} text-red-15`}
        isOnRequestClassName={`${priceClassName} text-black`}
      />
    </div>
	);
});